/** @graphql cc **/
import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useAudioContentQuery$data,
	useAudioContentQuery$variables,
} from './__generated__/useAudioContentQuery.graphql.ts';

const AudioContentQuery = graphql`
	query useAudioContentQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			title
			subType
			emoji: properties(key: "emoji-title-published") {
				nodes {
					id
					value
				}
			}
			history {
				createdBy {
					displayName
					profilePicture {
						path
					}
				}
				ownedBy {
					displayName
					profilePicture {
						path
					}
				}
			}
			links {
				webui
				base
			}
			properties(keys: ["emoji-title-published", "editor"]) {
				nodes {
					value
					key
				}
			}
		}
	}
`;

export const useAudioContentQuery = ({
	contentId,
}: {
	contentId: string;
}): {
	data: useAudioContentQuery$data | undefined;
} => {
	const { data } = useQueryInterop<useAudioContentQuery$data, useAudioContentQuery$variables>(
		AudioContentQuery,
		{
			variables: {
				contentId,
			},
			skip: !contentId,
			fetchPolicy: 'cache-first',
		},
	);

	return { data };
};
